import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { GENERAL_SETTINGS_LINK } from '../../../../../shared/navigation/constants';

@Component({
  selector: 'yi-woo-setup',
  template: require('./woo_setup.component.html'),
  styles: [require('./woo_setup.component.scss')]

})

export class WooSetupComponent extends AccordionContentComponent {

  private generalSettingsLink = GENERAL_SETTINGS_LINK;

  linkToCreds() {
    this.redirectService.redirectTo(this.generalSettingsLink, true);
  }
}
